// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3SAfG","btnBlock":"Button_btnBlock__2qy_e"};